module.exports = __webpack_public_path__ + "img/patient-email.0ed6fbca.png";